import { render, staticRenderFns } from "./Directores.vue?vue&type=template&id=e625942c&"
import script from "./Directores.vue?vue&type=script&lang=js&"
export * from "./Directores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports